import Vue from 'vue'
import settings from '@/model/settings'

function getDayMonth (date, short) {
  if (date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    var day = date.getDate()
    var options = { month: short?'short':'long' }
    var weekday = new Intl.DateTimeFormat(settings.intl.locale, options).format(date)
    var resp = `${day} ${weekday}`
    return resp
  }
  return ''
}

function getDayMonthYear (date, short) {
  if (date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    //var day = date.getDate()    
    var options = { month: short?'short':'long' }
    var month = new Intl.DateTimeFormat(settings.intl.locale, options).format(date)
    var year = new Intl.DateTimeFormat(settings.intl.locale, { year: 'numeric' }).format(date)
    var day = new Intl.DateTimeFormat(settings.intl.locale, { day: '2-digit' }).format(date)
    var resp = `${day} ${month} ${year}`
    return resp
  }
  return ''
}


Vue.filter('paperDateYear', date => {
  return getDayMonthYear(date, true)
})

Vue.filter('longPaperDateYear', date => {
  return getDayMonthYear(date, false)
})

Vue.filter('paperDate', date => {
  return getDayMonth(date, true)
})

Vue.filter('longPaperDate', date => {
  return getDayMonth(date, false)
})

Vue.filter('isoDate', date => {
  if (date) {
    var d = new Date(date)
    return d.toISOString().substring(0, 10)
  }
})

Vue.filter('toLocalDate', date => {
  if (date) {
    var d = new Date(date)
    return d.toLocaleDateString('sv-SE')
  }
})

